import ActivityIndicator from "./ActivityIndicator";

export {
    ActivityIndicator as default,
};
